import type { FetchRequestError } from "@lib/errors";
import { FetchUserEncodedError } from "@lib/errors/FetchUserEncodedError";

export interface AppsMultiLanguageSettingsDeleteLocaleLocaleIdProps {
  localeId: string;
}

export interface AppsMultiLanguageSettingsDeleteLocaleLocaleIdResult {
  success: boolean;
}

export type DeleteNonExistingLocaleError = FetchUserEncodedError<"DELETE_NON_EXISTING_LOCALE">;

export type DeleteLocaleErrors = DeleteNonExistingLocaleError;

export const isDeleteLocaleError = (error: FetchRequestError): error is DeleteLocaleErrors => {
  return error instanceof FetchUserEncodedError;
};
